import { SubLocalities } from '../interfaces/address'

export const INIT_SUB_LOCALITIES: SubLocalities = {
  region: [],
  district: [],
  commune: [],
  arrondissement: [],
  quartier: [],
}
